//#region  imports
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

//#endregion imports
//#region  internal imports
import { HttpProvider } from 'app/core/common/http-provider.service';
import { Constant } from 'app/core/common/constant';
import { Login } from 'app/core/model/authentication/login.modal';
import { SignUp } from 'app/core/model/authentication/signup.modal';
import { LoggedUser } from 'app/core/model/users/logged-user.modal';
//#endregion internal imports

@Injectable({
  providedIn: 'root',
})
export class AuthenticationService extends HttpProvider {

//#region Variable Declaration

private readonly authenticateEndpoint = '/login/';
private readonly logoutEndpoint = '/logout/';
private readonly forgotPasswordEndpoint = '/forgot_password/';
private readonly resetPasswordEndpoint = '/reset_password/';
private readonly organizationSetupEndpoint = '/organization_sign_up/';
private readonly validateEmailEndpoint = '/validate_email/';
private readonly validateMobileEndpoint = '/validate_mobile/';
private readonly paymentStatusEndpoint = '/payment_link_success_fail/';
setUpData: SignUp;

private readonly countryCodeEndpoint = '/country/';
private readonly paymentLinkEndpoint = '/razor_pay_payment_link_creation/';
private readonly orgValidationEndpoint = '/org_validation/';
private readonly changeUserDataEndpoint = '/organization_data_change/';
private readonly orgEmailVerifierEndpoint = '/org_email_verification/';
private readonly userDataViaVcipIdEndpoint = '/kyc/get_user_data_via_vcipid/';
private readonly accountDeletionEndpoint = '/account_deletion/';
private readonly userMobileVerifierEndpoint = '/mobile_verification_kyc/';
private readonly userProfileDetailsEndpoint = '/user_profile/';

//#endregion

  constructor(httpClient: HttpClient) {
    super(httpClient);
  }

  //#region Dropdown
  getCountryCode(activated_only=1) {
    const queryParams = {
      activated_only:activated_only
    };
    return this.get(this.countryCodeEndpoint, true, {
      params: this.toHttpParams(queryParams),
    });
  }
  getIndustry() {
    // throw new Error('Method not implemented.');
  }
  getOrganizationSize() {
    // throw new Error('Method not implemented.');
  }

  //#endregion

  // NOTE(security): localStorage is vulnerable to XSS. A full fix requires the backend
  // to set tokens via httpOnly cookies. Until then, all token reads/writes must go through
  // these methods — never access localStorage for tokens directly elsewhere.
  public getToken(): string | null {
    return localStorage.getItem(Constant.LocalStorageKey.Token);
  }

  public setToken(token: string): void {
    if (!token || typeof token !== 'string') return;
    // Basic JWT structure check (3 Base64URL segments separated by dots)
    const isJwt = /^[A-Za-z0-9\-_]+\.[A-Za-z0-9\-_]+\.[A-Za-z0-9\-_]*$/.test(token);
    if (!isJwt) {
      console.error('setToken: rejected malformed token');
      return;
    }
    localStorage.setItem(Constant.LocalStorageKey.Token, token);
  }

  public clearToken(): void {
    localStorage.removeItem(Constant.LocalStorageKey.Token);
  }

  public signUp(userInfo: Login) {
    this.setUpData = new SignUp();
    this.setUpData.email = userInfo.username;
    this.setUpData.password = userInfo.password;
  }

  public login(userInfo: Login) {
    this.setUpData = new SignUp();
    this.setUpData.email = userInfo.username;
    return this.post(this.authenticateEndpoint, userInfo);
  }

  logout() {
    return this.get(this.logoutEndpoint);
  }

  sendForgotPasswordMail(mail) {
    return this.post(this.forgotPasswordEndpoint, mail);
  }

  resetPassword(value: any) {
    return this.put(this.resetPasswordEndpoint, value);
  }

  checkResetPassword(value: any) {
    return this.post(this.resetPasswordEndpoint, value);
  }

  saveOrganizationSetup(value: any) {
    return this.post(this.organizationSetupEndpoint, value);
  }

  validateEmail(value: any) {
    return this.post(this.validateEmailEndpoint, value);
  }
  validateMobile(value: any) {
    return this.post(this.validateMobileEndpoint, value);
  }
  //#region  get/set
  getSetUpData(): SignUp {
    return this.setUpData;
  }

  getUserRoute(user: LoggedUser, currentRole) {
    switch (currentRole) {
      case Constant.RoleName.Admin:
        if (user.primary_account && !user.status) {
          return Constant.SetUpRoute;
        } else {
          return Constant.DashboardRoute.Admin;
        }
      case Constant.RoleName.Finance:
        return Constant.DashboardRoute.Finance;
      case Constant.RoleName.Manager:
        return Constant.DashboardRoute.Manager;
      case Constant.RoleName.User:
        return Constant.DashboardRoute.User;
      default:
        // Constant.SetUpRoute
        return null;
    }
  }

  validatePaymentstatus(element: any) {
    return this.post(this.paymentStatusEndpoint, element);
  }

  getProformById(pi_id: number) {
    return this.get(`/proposal/${pi_id}`);
  }

  getPaymentLink(elemnt: any) {
    return this.post(this.paymentLinkEndpoint, elemnt);
  }

  getOrganizationVerification(mode, overwrite) {
    const queryParams = {
      verification: mode,
      overwrite: overwrite,
    };
    return this.get(this.orgValidationEndpoint, true, {
      params: this.toHttpParams(queryParams),
    });
  }

  checkOrganizationVerification(elemnt: any) {
    return this.post(this.orgValidationEndpoint, elemnt);
  }

  changeuserData(data) {
    return this.post(this.changeUserDataEndpoint, data);
  }

  verifyOrganizationEmail(data) {
    return this.post(this.orgEmailVerifierEndpoint, data);
  }

  deletionAccount(data) {
    return this.post(this.accountDeletionEndpoint, data);
  }

  getUserDataViaVCIPID(data,country) {
    const queryParams = {
      vcipid: data,
      country:country
    };
    return this.get(this.userDataViaVcipIdEndpoint, true, {
      params: this.toHttpParams(queryParams),
    });
  }


  getUserverificationOTP(data,country) {
    const queryParams = {
      vcipid: data,
      country:country
    };
    return this.get(this.userMobileVerifierEndpoint, true, {
      params: this.toHttpParams(queryParams),
    });
  }

  validateUserOtp(data) {
    return this.post(this.userMobileVerifierEndpoint, data);
  }

  // Fetch current user profile details (called on app initialization/refresh)
  getUserProfileDetails() {
    return this.get(this.userProfileDetailsEndpoint);
  }
  //#endregion
}
